import Vue from 'vue'

export default {
	state: {
		segments: [],
		nextSegments: []
	},
	mutations: {
		loadSegments (state, payload) {
			state.segments = payload
		},
		addSegment (state, payload) { 
			const index = state.segments.length
			Vue.set(state.segments, index, payload)  
		},
		changeSegment (state, payload) {
			const segment = state.segments.find(s => s.id === payload.id)
			Vue.set(state.segments, state.segments.indexOf(segment), payload)  
		},
		deleteSegment (state, payload) {
			state.segments = state.segments.filter(segment => segment.id !== payload) 
		}
	},
	actions: {
		async fetchSegments ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)

			let gameId = 'game'
			let round = 'round'

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId += getters.gameId
				round += getters.currentRound
			}

			const resArr = []
			//console.log(payload)
			try {
				const segments = await Vue.$db.collection(gameId).doc(round)
				.collection('segments')
				.get()

				if (segments) {
					segments.forEach(doc => {
						const segment = doc.data()

						let seg = {id: doc.id}

						for (let key in segment) {
							seg[key] = segment[key]
						}
						resArr.push(seg)
					})
					commit('loadSegments', resArr)
				}
				else {//no channels
					console.log('no segments')
				}
				
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addSegment ({commit, getters}, payload) {
			commit('clearError')
			commit('setLoading', true)

			let id = payload.segment.id

			try {

				if(!id) {
					const segmentRef = await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
					.collection('segments')
					.add(payload.segment)
				
					payload.segment.id = segmentRef.id
				}
				else {
					delete payload.segment.id//delete id 
					await Vue.$db.collection('game' + payload.gameId).doc('round'+ payload.round)
					.collection('segments')
					.doc(id)
					.set(payload.segment)
				
					payload.segment.id = id
				}
								
				commit('setLoading', false)

				if (getters.currentRound == payload.round) {
					commit('addSegment', payload.segment)
				}
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async changeSegment ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.segment.id

			delete payload.segment.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('segments').doc(id)
				.set(payload.segment)

				payload.segment.id = id

				commit('setLoading', false)
				commit('changeSegment', payload.segment)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteSegment ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('segments').doc(id).delete()

				commit('setLoading', false)
				commit('deleteSegment', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}
	},
	getters: {
		segments (state) {
			return state.segments
		}
	}
}